import { render, staticRenderFns } from "./ownerDetailCoupon.vue?vue&type=template&id=52f04b93&scoped=true"
import script from "./ownerDetailCoupon.vue?vue&type=script&lang=js"
export * from "./ownerDetailCoupon.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailCoupon.vue?vue&type=style&index=0&id=52f04b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f04b93",
  null
  
)

export default component.exports